class Accordion {
    constructor(el) {
      // Store the <details> element
      this.el = el;
      // Store the <summary> element
      this.summary = el.querySelector('summary');
      // Store the <div class="content"> element
      this.content = el.querySelector('.accordion__content');
  
      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
      // Detect user clicks on the summary element
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }
  
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.el.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.el.open) {
        this.open();
      // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }
  
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;
      
      // Store the current height of the element
      const startHeight = `${this.el.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;
      
      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }
      
      // Start a WAAPI animation
      this.animation = this.el.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }
  
    open() {
      // Apply a fixed height on the element
      this.el.style.height = `${this.el.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.el.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }
  
    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.el.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      
      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }
      
      // Start a WAAPI animation
      this.animation = this.el.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }
  
    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.el.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.el.style.height = this.el.style.overflow = '';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product__accordion details').forEach((el) => {
        new Accordion(el);
        console.log('Accordion initialized', el);
    });
});



const observer1 = new MutationObserver(() => {
  const customElement = document.querySelectorAll('.media-slider');
  console.log(customElement);
  if (customElement) {
    customElement.forEach((el) => {
      console.log(el.shadowRoot);
      if (el.shadowRoot) {
        const style = document.createElement("style");
        style.textContent = `
          .swiper-button-prev svg,
          .swiper-button-next svg {
            width: 15px !important;
            height: 15px !important;
          }
          .swiper-button-next svg path,
          .swiper-button-prev svg path {
            fill:rgb(0, 0, 0);
          }
        `;
        el.shadowRoot.appendChild(style);
      }
    });
    observer1.disconnect(); // Stop observing once the element is found
  }
  });
  observer1.observe(document.body, { childList: true, subtree: true });

  const lazyImages = document.querySelectorAll(".lazy-load-image");
  
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.onload = () => {
            img.classList.add("loaded");
          };
          observer.unobserve(img);
        }
      });
    });
  
    lazyImages.forEach(img => imageObserver.observe(img));

   document.addEventListener("click", function(event) {
  const swatch = event.target.closest(".related-color-swatch");
  if (swatch) {
    const colorHref = swatch.dataset.href;
    if (colorHref) {
      console.log("clicked");
      window.location.href = colorHref;
    }
  }
});


function smoothScrollTo(targetY, duration = 500) {  
  const startY = window.scrollY; // Current scroll position  
  const distance = targetY - startY; // Distance to scroll  
  const startTime = performance.now(); // Start time of the animation  

  function animateScroll(currentTime) {  
    const elapsedTime = currentTime - startTime; // Time elapsed since the animation started  
    const progress = Math.min(elapsedTime / duration, 1); // Progress (0 to 1)  

    // Ease-in-out function for smooth animation  
    const easeInOutQuad = progress < 0.5  
      ? 2 * progress * progress  
      : 1 - Math.pow(-2 * progress + 2, 2) / 2;  

    // Calculate the current scroll position  
    const currentY = startY + distance * easeInOutQuad;  

    // Scroll to the current position  
    window.scrollTo(0, currentY);  

    // Continue the animation if not yet complete  
    if (progress < 1) {  
      requestAnimationFrame(animateScroll);  
    }  
  }  

  requestAnimationFrame(animateScroll);  
}  



//** sticky scroll restore to position 0 on-click **//

  window.setTimeout(()=>{
        if (document.body.classList.contains('product')) {  
              const labels = document.querySelectorAll('.product-form-variants-sticky label');  
              if (labels){
                labels.forEach(label => {  
                  label.addEventListener('click', (event) => { 
                      setTimeout(() => {  
                        smoothScrollTo(0);  
                      }, 500);
                  });  
                });  
              } 
        }
  },1000);  



            //  const inputs = document.querySelectorAll('.product-form-variants-sticky .size-variants .size-variant input');  
            //  console.log(inputs); 
            //  if (inputs){
            //     inputs.forEach(input => {  
            //       input.addEventListener('click', (event) => { 
            //         event.target.classList.add("checked"); // Add class to the clicked radio button

            //       });
            //     });
            //   }
